import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useDateOptions } from "@shared/options";

export function MagazineTemplateForm() {
  const translate = useTranslate();
  const { getMonthOptions, getYearOptions } = useDateOptions();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="file"
          label={translate("magazine/magazine_template_admin.fields.file")}
          shape="square"
          size={150}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="cover"
          label={translate("magazine/magazine_template_admin.fields.cover")}
          shape="square"
          size={150}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="reference_month"
          label={translate("magazine/magazine_template_admin.fields.reference_month")}
          options={getMonthOptions()}
          type="number"
          fullWidth
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="reference_year"
          label={translate("magazine/magazine_template_admin.fields.reference_year")}
          options={getYearOptions(2022)}
          type="number"
          fullWidth
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="page_to_replace"
          label={translate("magazine/magazine_template_admin.fields.page_to_replace")}
          type="number"
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="article_title"
          label={translate("magazine/magazine_template_admin.fields.article_title")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="article_content"
          label={translate("magazine/magazine_template_admin.fields.article_content")}
          required
          multiline
          rows={4}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
